export var STATE_STORAGE_KEY = 'lendi_auth';
export var STATE_STORAGE_VERSION = '1';
//# sourceMappingURL=State.js.map